import React from 'react'
import AdminLayout from '../../../layouts/AdminLayout'

const NewUserSignup = () => {
  return (
    <div>
      <AdminLayout>
        <div className="ct_px_40 mt-4">
          <div className="d-flex align-items-center gap-3 justify-content-between mb-4 ct_flex_col_1199 pb">
            <div>
              <h4 className="mb-0 ct_fs_20 mb-1">New User Signups- June 2025</h4>
              <p className="mb-0 ct_text_clr_757886">
                Track and manage all users who joined the platform this month
              </p>
            </div>
            <div className="d-flex align-items-center gap-3 justify-content-end  ct_flex_col_575">
              <button className="ct_yellow_btn ct_h_48 ct_w_100_575">
                Send Welcome Message
              </button>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-3 col-md-6 ct_mb_30">
              <div class="ct_outline_bg h-100">
                <div class="d-flex align-items-start justify-content-between gap-2">
                  <div>
                    <p class="ct_fs_14 ct_darkblue_text ct_mb_16">Freelancers Signed Up</p>
                    <h4 class="ct_fs_24 mb-0">90</h4>
                  </div>
                  <img alt="" src="../assets/img/dash_icon_1.png" />
                </div>
                <ul class="d-flex align-items-center gap-2 ct_mt_16 pb-3">
                  <li class="ct_fs_12 ct_orange_text">
                    <svg
                      width="23"
                      height="24"
                      viewBox="0 0 23 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_1696_32114)">
                        <path
                          d="M7.03156 16.2038L15.3574 8.03125"
                          stroke="#FB8500"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>
                        <path
                          d="M15.5339 14.3985L15.5952 7.79909L8.99583 7.73778"
                          stroke="#FB8500"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>
                      </g>
                      <defs>
                        <clipPath id="clip0_1696_32114">
                          <rect
                            width="16"
                            height="16"
                            fill="white"
                            transform="translate(11.418 0.6875) rotate(45.5323)"
                          ></rect>
                        </clipPath>
                      </defs>
                    </svg>
                    24%
                  </li>
                  <li class="ct_text_op_2">|</li>
                  <li class="ct_grey_text ct_fs_12">
                    live ad campaign running across
                  </li>
                </ul>
                <div class="d-flex align-items-center justify-content-between gap-2 ct_pt_16 ct_border_top_light ">
                  <a href="#" class="ct_yellow_link ct_fs_14">
                    View Report
                  </a>
                  <a href="#">
                    <svg
                      width="14"
                      height="13"
                      viewBox="0 0 14 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.834 6.3125L1.16732 6.3125M12.834 6.3125L7.83398 11.3125M12.834 6.3125L7.83398 1.3125"
                        stroke="#FFB703"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 ct_mb_30">
              <div class="ct_outline_bg h-100">
                <div class="d-flex align-items-start justify-content-between gap-2">
                  <div>
                    <p class="ct_fs_14 ct_darkblue_text ct_mb_16">
                      Enterprise Users
                    </p>
                    <h4 class="ct_fs_24 mb-0">45</h4>
                  </div>
                  <img alt="" src="../assets/img/dash_icon_2.png" />
                </div>
                <ul class="d-flex align-items-center gap-2 ct_mt_16 pb-3">
                  <li class="ct_fs_12 ct_sky_blue_text">
                    38%
                    <svg
                      width="22"
                      height="22"
                      viewBox="0 0 22 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_1696_32145)">
                        <path
                          d="M5.73231 8.00261L15.8359 13.8359"
                          stroke="#8ECAE6"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>
                        <path
                          d="M9.74891 15.7105L16.1237 14.0024L14.4156 7.6276"
                          stroke="#8ECAE6"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>
                      </g>
                      <defs>
                        <clipPath id="clip0_1696_32145">
                          <rect
                            width="16"
                            height="16"
                            fill="white"
                            transform="translate(21.8555 8.07031) rotate(120)"
                          ></rect>
                        </clipPath>
                      </defs>
                    </svg>
                  </li>
                  <li class="ct_text_op_2">|</li>
                  <li class="ct_grey_text ct_fs_12">
                    total times ads were shown
                  </li>
                </ul>
                <div class="d-flex align-items-center justify-content-between gap-2 ct_pt_16 ct_border_top_light ">
                  <a href="#" class="ct_dark_blue_link ct_fs_14">
                    View Report
                  </a>
                  <a href="#">
                    <svg
                      width="14"
                      height="13"
                      viewBox="0 0 14 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.834 6.92969L1.16732 6.92969M12.834 6.92969L7.83398 11.9297M12.834 6.92969L7.83398 1.92969"
                        stroke="#023047"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 ct_mb_30">
              <div class="ct_outline_bg h-100">
                <div class="d-flex align-items-start justify-content-between gap-2">
                  <div>
                    <p class="ct_fs_14 ct_darkblue_text ct_mb_16">
                      Coaches
                    </p>
                    <h4 class="ct_fs_24 mb-0">20</h4>
                  </div>
                  <img alt="" src="../assets/img/dash_icon_3.png" />
                </div>
                <ul class="d-flex align-items-center gap-2 ct_mt_16 pb-3">
                  <li class="ct_fs_12 ct_orange_text">
                    <svg
                      width="23"
                      height="24"
                      viewBox="0 0 23 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_1696_32114)">
                        <path
                          d="M7.03156 16.2038L15.3574 8.03125"
                          stroke="#FB8500"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>
                        <path
                          d="M15.5339 14.3985L15.5952 7.79909L8.99583 7.73778"
                          stroke="#FB8500"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>
                      </g>
                      <defs>
                        <clipPath id="clip0_1696_32114">
                          <rect
                            width="16"
                            height="16"
                            fill="white"
                            transform="translate(11.418 0.6875) rotate(45.5323)"
                          ></rect>
                        </clipPath>
                      </defs>
                    </svg>
                    24%
                  </li>
                  <li class="ct_text_op_2">|</li>
                  <li class="ct_grey_text ct_fs_12">
                    click through rate across
                  </li>
                </ul>
                <div class="d-flex align-items-center justify-content-between gap-2 ct_pt_16 ct_border_top_light ">
                  <a href="#" class="ct_dark_blue_link ct_fs_14">
                    View Report
                  </a>
                  <a href="#">
                    <svg
                      width="14"
                      height="13"
                      viewBox="0 0 14 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.834 6.92969L1.16732 6.92969M12.834 6.92969L7.83398 11.9297M12.834 6.92969L7.83398 1.92969"
                        stroke="#023047"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 ct_mb_30">
              <div class="ct_outline_bg h-100">
                <div class="d-flex align-items-start justify-content-between gap-2">
                  <div>
                    <p class="ct_fs_14 ct_darkblue_text ct_mb_16">
                      Pending Approval
                    </p>
                    <h4 class="ct_fs_24 mb-0">10 </h4>
                  </div>
                  <img alt="" src="../assets/img/dash_icon_4.png" />
                </div>
                <ul class="d-flex align-items-center gap-2  ct_mt_16 pb-3">
                  <li class="ct_fs_12 ct_orange_text">
                    <svg
                      width="23"
                      height="24"
                      viewBox="0 0 23 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_1696_32114)">
                        <path
                          d="M7.03156 16.2038L15.3574 8.03125"
                          stroke="#FB8500"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>
                        <path
                          d="M15.5339 14.3985L15.5952 7.79909L8.99583 7.73778"
                          stroke="#FB8500"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>
                      </g>
                      <defs>
                        <clipPath id="clip0_1696_32114">
                          <rect
                            width="16"
                            height="16"
                            fill="white"
                            transform="translate(11.418 0.6875) rotate(45.5323)"
                          ></rect>
                        </clipPath>
                      </defs>
                    </svg>
                    24%
                  </li>
                  <li class="ct_text_op_2">|</li>
                  <li class="ct_grey_text ct_fs_12">
                    summary of all uploaded
                  </li>
                </ul>
                <div class="d-flex align-items-center justify-content-between gap-2 ct_pt_16 ct_border_top_light ">
                  <a href="#" class="ct_dark_blue_link ct_fs_14">
                    View Report
                  </a>
                  <a href="#">
                    <svg
                      width="14"
                      height="13"
                      viewBox="0 0 14 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.834 6.92969L1.16732 6.92969M12.834 6.92969L7.83398 11.9297M12.834 6.92969L7.83398 1.92969"
                        stroke="#023047"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="d-flex align-items-center gap-3 justify-content-between mb-4 ct_flex_col_1199 pb">
            <div>
              <h4 className="mb-0 ct_fs_20 mb-1">New Sign-Ups</h4>
              <p className="mb-0 ct_text_clr_757886">
                Manage all uploaded google ads in one place. View status, make edits, or track performance
              </p>
            </div>
            <div className="d-flex align-items-center gap-3 justify-content-end  ct_flex_col_575">
              <div className="position-relative ct_w_100_575">
                <input
                  type="text"
                  className="form-control ct_input ct_h_35 ps-5"
                  placeholder="Search by Name"
                />
                <i className="fa-solid fa-search ct_input_icon_left"></i>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-3 mb-4 mb-md-0">
              <div class="ct_filter_btn mb-0 d-block d-lg-none ">
                <button class="ct_outline_grey ct_yellow_btn ct_h_35 d-flex align-items-center gap-2">
                  Filter
                  <img alt="" src="../assets/img/octicon_filter-16.png" />
                </button>
              </div>
              <div className={`ct_filter_sidebar ct_custom_scroll p-0`}>
                <div className="mt-2">
                  <h5 className="ct_fs_16 mb-3">Status</h5>
                  <ul>
                    <li>
                      <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="flexCheckDefault"
                        />
                        <label for="" className="ct_text_clr_757886">
                          Active
                        </label>
                      </div>
                    </li>
                    <li className="mt-2">
                      <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="flexCheckDefault"
                        />
                        <label for="" className="ct_text_clr_757886">
                          Suspended
                        </label>
                      </div>
                    </li>
                    <li className="mt-2">
                      <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="flexCheckDefault"
                        />
                        <label for="" className="ct_text_clr_757886">
                          Pending
                        </label>
                      </div>
                    </li>

                  </ul>
                </div>
                <div className="mt-4">
                  <h5 className="ct_fs_16 mb-3">User Role</h5>
                  <ul>
                    <li>
                      <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="flexCheckDefault"
                        />
                        <label for="" className="ct_text_clr_757886">
                          Freelancer
                        </label>
                      </div>
                    </li>
                    <li className="mt-2">
                      <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="flexCheckDefault"
                        />
                        <label for="" className="ct_text_clr_757886">
                          Enterprise
                        </label>
                      </div>
                    </li>
                    <li className="mt-2">
                      <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="flexCheckDefault"
                        />
                        <label for="" className="ct_text_clr_757886">
                          Coach
                        </label>
                      </div>
                    </li>
                    <li className="mt-2">
                      <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="flexCheckDefault"
                        />
                        <label for="" className="ct_text_clr_757886">
                          Founder
                        </label>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="mt-4">
                  <h5 className="ct_fs_16 mb-3">Date Range</h5>
                  <ul>
                    <li>
                      <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="flexCheckDefault"
                        />
                        <label for="" className="ct_text_clr_757886">
                          Today
                        </label>
                      </div>
                    </li>
                    <li className="mt-2">
                      <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="flexCheckDefault"
                        />
                        <label for="" className="ct_text_clr_757886">
                          Last 7 Days
                        </label>
                      </div>
                    </li>
                    <li className="mt-2">
                      <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="flexCheckDefault"
                        />
                        <label for="" className="ct_text_clr_757886">
                          Last 30 Days
                        </label>
                      </div>
                    </li>
                    <li className="mt-2">
                      <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="flexCheckDefault"
                        />
                        <label for="" className="ct_text_clr_757886">
                          Custom Range
                        </label>
                      </div>
                    </li>


                  </ul>
                </div>
                <div className="mt-4">
                  <h5 className="ct_fs_16 mb-3">Sort By</h5>
                  <ul>
                    <li>
                      <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="flexCheckDefault"
                        />
                        <label for="" className="ct_text_clr_757886">
                          Newest First
                        </label>
                      </div>
                    </li>
                    <li className="mt-2">
                      <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="flexCheckDefault"
                        />
                        <label for="" className="ct_text_clr_757886">
                          Oldest First
                        </label>
                      </div>
                    </li>
                    <li className="mt-2">
                      <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="flexCheckDefault"
                        />
                        <label for="" className="ct_text_clr_757886">
                          Most Viewed
                        </label>
                      </div>
                    </li>
                    <li className="mt-2">
                      <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="flexCheckDefault"
                        />
                        <label for="" className="ct_text_clr_757886">
                          Highest CTR
                        </label>
                      </div>
                    </li>
                    <li className="mt-2">
                      <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="flexCheckDefault"
                        />
                        <label for="" className="ct_text_clr_757886">
                          Alphabetical (A-Z)
                        </label>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-9  mb-4 mb-md-0">
              <div class="table-responsive ct_custom_table ct_custom_table2 pt-2">
                <table class="table">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Role</th>
                      <th>Status</th>
                      <th>SignUp Date</th>
                      <th>Last Active</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <div class="d-flex align-items-center gap-3"><img class="ct_img_40" src="../assets/img/user_22.jpeg" /><div><h5 class="ct_fs_16 ct_fw_600 mb-1">Nuray Aksoy</h5><p class="mb-0 ct_grey_text">nukrayaksoy@gmail.com</p></div></div>
                      </td>
                      <td>Coach</td>
                      <td>
                        <span class="ct_publish_badge">Active</span>
                      </td>
                      <td>May 2, 2025</td>
                      <td>
                        <div className="d-flex flex-column gap-2 position-relative">
                          <select
                            className="form-control ct_input border-0 py-0 ct_line_h_auto"
                            style={{ appearance: "auto" }}
                          >
                            <option>Aug 24,2025</option>
                          </select>
                          <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                        </div>
                      </td>

                      <td>
                        <div class="ct_right_dropdown dropdown">
                          <button
                            id="dropdownMenuButton"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <i class="fa-solid fa-ellipsis"></i>
                          </button>
                          <ul
                            class="dropdown-menu"
                            aria-labelledby="dropdownMenuButton1"
                          >
                            <li>
                              <a class="dropdown-item">View Profile</a>
                            </li>
                            <li>
                              <a
                                class="dropdown-item ct_darksky_blue_text"
                                href="javascript:void(0)"
                              >
                                Approve Account
                              </a>
                            </li>
                            <li>
                              <a
                                class="dropdown-item "
                                href="javascript:void(0)"
                              >
                                Send Message
                              </a>
                            </li>
                            <li>
                              <a
                                class="dropdown-item  ct_yellow_text"
                                href="javascript:void(0)"
                                data-bs-target="#ct_suspend_account"
                                data-bs-toggle="modal"
                              >
                                Suspend User
                              </a>
                            </li>
                            <li>
                              <a
                                class="dropdown-item ct_orange_text"
                                href="javascript:void(0)"
                              >
                                Remove
                              </a>
                            </li>
                          </ul>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <div class="d-flex align-items-center gap-3"><img class="ct_img_40" src="../assets/img/user_22.jpeg" /><div><h5 class="ct_fs_16 ct_fw_600 mb-1">Nuray Aksoy</h5><p class="mb-0 ct_grey_text">nukrayaksoy@gmail.com</p></div></div>
                      </td>
                      <td>Coach</td>
                      <td>
                        <span class="ct_publish_badge">Active</span>
                      </td>
                      <td>May 2, 2025</td>
                      <td>
                        <div className="d-flex flex-column gap-2 position-relative">
                          <select
                            className="form-control ct_input border-0 py-0 ct_line_h_auto"
                            style={{ appearance: "auto" }}
                          >
                            <option>Aug 24,2025</option>
                          </select>
                          <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                        </div>
                      </td>

                      <td>
                        <div class="ct_right_dropdown dropdown">
                          <button
                            id="dropdownMenuButton"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <i class="fa-solid fa-ellipsis"></i>
                          </button>
                          <ul
                            class="dropdown-menu"
                            aria-labelledby="dropdownMenuButton1"
                          >
                            <li>
                              <a class="dropdown-item">View Profile</a>
                            </li>
                            <li>
                              <a
                                class="dropdown-item ct_darksky_blue_text"
                                href="javascript:void(0)"
                              >
                                Approve Account
                              </a>
                            </li>
                            <li>
                              <a
                                class="dropdown-item "
                                href="javascript:void(0)"
                              >
                                Send Message
                              </a>
                            </li>
                            <li>
                              <a
                                class="dropdown-item  ct_yellow_text"
                                href="javascript:void(0)"
                                data-bs-target="#ct_suspend_account"
                                data-bs-toggle="modal"
                              >
                                Suspend User
                              </a>
                            </li>
                            <li>
                              <a
                                class="dropdown-item ct_orange_text"
                                href="javascript:void(0)"
                              >
                                Remove
                              </a>
                            </li>
                          </ul>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="d-flex align-items-center gap-3"><img class="ct_img_40" src="../assets/img/user_22.jpeg" /><div><h5 class="ct_fs_16 ct_fw_600 mb-1">Nuray Aksoy</h5><p class="mb-0 ct_grey_text">nukrayaksoy@gmail.com</p></div></div>
                      </td>
                      <td>Coach</td>
                      <td>
                        <span class="ct_suspended">Suspended</span>
                      </td>
                      <td>May 2, 2025</td>
                      <td>
                        <div className="d-flex flex-column gap-2 position-relative">
                          <select
                            className="form-control ct_input border-0 py-0 ct_line_h_auto"
                            style={{ appearance: "auto" }}
                          >
                            <option>Aug 24,2025</option>
                          </select>
                          <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                        </div>
                      </td>

                      <td>
                        <div class="ct_right_dropdown dropdown">
                          <button
                            id="dropdownMenuButton"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <i class="fa-solid fa-ellipsis"></i>
                          </button>
                          <ul
                            class="dropdown-menu"
                            aria-labelledby="dropdownMenuButton1"
                          >
                            <li>
                              <a class="dropdown-item">View Profile</a>
                            </li>
                            <li>
                              <a
                                class="dropdown-item ct_darksky_blue_text"
                                href="javascript:void(0)"
                              >
                                Approve Account
                              </a>
                            </li>
                            <li>
                              <a
                                class="dropdown-item "
                                href="javascript:void(0)"
                              >
                                Send Message
                              </a>
                            </li>
                            <li>
                              <a
                                class="dropdown-item  ct_yellow_text"
                                href="javascript:void(0)"
                                data-bs-target="#ct_suspend_account"
                                data-bs-toggle="modal"
                              >
                                Suspend User
                              </a>
                            </li>
                            <li>
                              <a
                                class="dropdown-item ct_orange_text"
                                href="javascript:void(0)"
                              >
                                Remove
                              </a>
                            </li>
                          </ul>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="d-flex align-items-center gap-3"><img class="ct_img_40" src="../assets/img/user_22.jpeg" /><div><h5 class="ct_fs_16 ct_fw_600 mb-1">Nuray Aksoy</h5><p class="mb-0 ct_grey_text">nukrayaksoy@gmail.com</p></div></div>
                      </td>
                      <td>Coach</td>
                      <td>
                        <span class="ct_draft_badge">Pending</span>
                      </td>
                      <td>May 2, 2025</td>
                      <td>
                        <div className="d-flex flex-column gap-2 position-relative">
                          <select
                            className="form-control ct_input border-0 py-0 ct_line_h_auto"
                            style={{ appearance: "auto" }}
                          >
                            <option>Aug 24,2025</option>
                          </select>
                          <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                        </div>
                      </td>

                      <td>
                        <div class="ct_right_dropdown dropdown">
                          <button
                            id="dropdownMenuButton"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <i class="fa-solid fa-ellipsis"></i>
                          </button>
                          <ul
                            class="dropdown-menu"
                            aria-labelledby="dropdownMenuButton1"
                          >
                            <li>
                              <a class="dropdown-item">View Profile</a>
                            </li>
                            <li>
                              <a
                                class="dropdown-item ct_darksky_blue_text"
                                href="javascript:void(0)"
                              >
                                Approve Account
                              </a>
                            </li>
                            <li>
                              <a
                                class="dropdown-item "
                                href="javascript:void(0)"
                              >
                                Send Message
                              </a>
                            </li>
                            <li>
                              <a
                                class="dropdown-item  ct_yellow_text"
                                href="javascript:void(0)"
                                data-bs-target="#ct_suspend_account"
                                data-bs-toggle="modal"
                              >
                                Suspend User
                              </a>
                            </li>
                            <li>
                              <a
                                class="dropdown-item ct_orange_text"
                                href="javascript:void(0)"
                              >
                                Remove
                              </a>
                            </li>
                          </ul>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </AdminLayout>
    </div>
  )
}

export default NewUserSignup